/**
 * Track dashboard enter — v7.4 P8
 *
 * Combines Sentry breadcrumb + PostHog analytics event for the 5 main centers.
 * Use: useEffect(() => trackCenter("cockpits", userContext), [])
 */
import { captureMessage } from "./sentry";
import { clinicalEvents } from "./posthog";

export type CenterId = "mission_control" | "clinical" | "soc" | "governance" | "ai" | "operations";

export function trackCenter(center: CenterId, userId?: string) {
  // PostHog: page view + breadcrumb
  clinicalEvents.cockpitEntered(center);
  // Sentry: breadcrumb (no error)
  captureMessage(`Center entered: ${center}`, "info", { center, userId });
}